import { Injectable } from '@angular/core';
import { UntilDestroy } from '@ngneat/until-destroy';
import { BehaviorSubject } from 'rxjs';

@UntilDestroy()
@Injectable({ providedIn: 'root' })
export class FullScreenService {
  private readonly isFullScreen$$ = new BehaviorSubject(false);
  readonly isFullScreen$ = this.isFullScreen$$;

  private readonly isFullHeight$$ = new BehaviorSubject(true);
  readonly isFullHeight$ = this.isFullHeight$$;

  setIsFullScreen(state: boolean) {
    this.isFullScreen$$.next(state);
  }

  setTabsFullHeight(state: boolean) {
    this.isFullHeight$$.next(state);
  }
}
